module.exports = __webpack_public_path__ + "img/1529072470.480aa329.jpg";